// extracted by mini-css-extract-plugin
export var deleteModal = "_fh-0";